import { render, staticRenderFns } from "./typeEdit.vue?vue&type=template&id=7e21660b&scoped=true"
import script from "./typeEdit.vue?vue&type=script&lang=js"
export * from "./typeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e21660b",
  null
  
)

export default component.exports